/**
 * Created by Christof Sander on 20.10.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'propertiesForm'
	],

	methods: {
		getDBPrivileges: function(allPrivileges, rolePrivileges, selectedPrivileges){
			var result = [];
			var privileges = {
				role: {},
				selected: {}
			};

			utils.forEach(rolePrivileges, function(rolePrivilege){
				privileges.role[rolePrivilege.attributes.privilegeID] = rolePrivilege.attributes;
			});
			utils.forEach(selectedPrivileges, function(selectedPrivilege){
				privileges.selected[selectedPrivilege.id] = selectedPrivilege;
			});

			utils.forEach(allPrivileges, function(privilege){
				if(privileges.selected[privilege.id] && !privileges.role[privilege.id]){
					// add
					result.push({
						attributes: {
							privilegeID: privilege.id
						}
					});
				}
				else if(!privileges.selected[privilege.id] && privileges.role[privilege.id]) {
					// delete
					result.push({
						attributes: {
							scopeRolePrivilegeID: privileges.role[privilege.id].scopeRolePrivilegeID
						},
						type: 'delete'
					});
				}
			});

			return result;
		},

		onDecision: function(options){
			if(options.decisionType === 'submit' && options.decisionOptions && options.decisionOptions.type === 'privileges'){
				var privilegeTreesComponent = this.registry.privileges.component;
				var rolePrivileges;
				if(!this.config.creationMode) rolePrivileges = this.resourceData.data.children.um_scopeRoles_privileges.data;
				var privileges = this.getDBPrivileges(
					privilegeTreesComponent.registry[0].tree.resourceData.treeData.nodes,
					rolePrivileges,
					options.data
				);

				if(!this.model.dirtyFields)                                 		this.model.dirtyFields = {};
				if(!this.model.dirtyFields.data)                            		this.model.dirtyFields.data = {};
				if(!this.model.dirtyFields.data.children)                   		this.model.dirtyFields.data.children = {};
				if(!this.model.dirtyFields.data.children.um_scopeRoles_privileges)  this.model.dirtyFields.data.children.um_scopeRoles_privileges = {};

				this.model.dirtyFields.data.children.um_scopeRoles_privileges.data = privileges;

				if(privileges.length > 0)   this.setDirty();
				else                        this.setClean();
			}
		},

		onAttachDone: function(){
			// preselect privileges if necessary
			if(!this.config.creationMode){
				var self = this;
				this.registry.privileges.component.treesReady(function(){
					self.registry.privileges.component.preSelectPrivileges(
						self.resourceData.data.children.um_scopeRoles_privileges.data,
						undefined,
						true
					);
				});
			}
		}
	}
};